import Script from 'next/script'
import { scripts } from '@/lib/ThirdPartyScripts/scripts'
import { type Dispatch, type SetStateAction } from 'react'

type Props = {
  setIsSprinklrLoaded: Dispatch<SetStateAction<boolean>>
}

export function SprinklrChat({ setIsSprinklrLoaded }: Props) {
  return (
    <Script
      id="sprinklr"
      dangerouslySetInnerHTML={{
        __html: scripts.sprinklr,
      }}
      strategy="lazyOnload"
      onReady={() => setIsSprinklrLoaded(true)}
    />
  )
}
